export default "__VITE_ASSET__2RB4od0C__"